import { Box, Flex, Spacer } from '@chakra-ui/layout';
import Link from 'next/link';

export const ForgotPasswordFooter = () => (
  <Flex width="100%">
    <Box w="auto">
      <Link href="/login" passHref>
        <a className="link link--secondary link--decorate">Back to login</a>
      </Link>
    </Box>
    <Spacer />
    <Box w="auto">
      <Link href="/register" passHref>
        <a className="link link--secondary link--decorate">Create account</a>
      </Link>
    </Box>
  </Flex>
)
